export default __webpack_public_path__ + "static/media/apex-legends-symbol-white.c2338957.png";